import React from "react";
import PropTypes from "prop-types";
import ctl from "@netlify/classnames-template-literals";

import Warning from "assets/images/svgs/warning.svg";

const FormSelect = ({
  label,
  type,
  options,
  placeholder,
  register,
  required,
  error,
}) => {
  const inputId = label ? label.replaceAll(" ", "-").toLowerCase() : "";
  // const [showMenu, setShowMenu] = useState(false);
  // const [selectedValue, setSelectedValue] = useState("");
  // const inputRef = useRef(null);

  //   useEffect(() => {
  //     const handler = setShowMenu(false);

  //     window.addEventListener("click", handler);
  //     return () => {
  //         window.removeEventListener("click", handler);
  //     };
  //   });

  // const handleInputClick = (e) => {
  //   e.stopPropagation();
  //   setShowMenu(!showMenu);
  // };

  // const onItemClicked = (option) => {
  //   // inputRef.current.value = option;
  //   document.getElementById("input").value = option;
  //   setSelectedValue(option);
  //   setShowMenu(false);
  //   // console.log(document.getElementById("input").value)
  // }

  const inputStyle = ctl(`
    flex
    justify-between
    ${baseStyles}
    ${error && inputErrorStyle}
`);

  return (
    // <div className={inputWrapStyle}>
    //   <input
    //     placeholder={placeholder}
    //     id={inputId}
    //     name={inputId}
    //     type={type}
    //     className={inputStyle}
    //     required={required}
    //     {...register}
    //   />

    //   {error && (
    //     <div className={errorMessageWrapStyle}>
    //       <Warning />
    //       <p className={errorMessageStyle}>{error}</p>
    //     </div>
    //   )}
    // </div>
    <div className={inputWrapStyle}>
      <div className={selectArea}>
        <select
          className={inputStyle}
          required={required}
          name={inputId}
          id={inputId}
          placeholder={placeholder}
          {...register}
        >
          {/* {selectedValue.length > 1? <span>{selectedValue}</span> : <span className={selectPlaceholder}>{placeholder}</span>}
                <span className={icon}>
                    <svg height="20" width="20" viewBox="0 0 20 20">
                        <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                    </svg> 
                </span> */}
          <option value="" disabled hidden selected>
            {placeholder}
          </option>
          {options.map(option => (
            <option
              key={option.value}
              value={option.value}
              className={dropOption}
            >
              {option.label}
            </option>
          ))}
        </select>
        {error && (
          <div className={errorMessageWrapStyle}>
            <Warning />
            <p className={errorMessageStyle}>{error}</p>
          </div>
        )}
      </div>
      {/* {showMenu && (
            <div className={drop}>
                {options.map((option) => (
                    <span key={option.value} className={dropOption} onClick={() => onItemClicked(option.label)}>{option.label}</span>
                ))}
            </div> 
        )} */}
    </div>
  );
};

const inputWrapStyle = ctl(`
  mb-8
  relative
`);

// const icon = ctl(`
// mr-4
// `);

const selectArea = ctl(`
mb-4
`);

// const drop = ctl(`
// bg-white
// shadow-lg
// shadow-black-500/50
// py-4
// rounded-[20px]
// absolute
// inset-x-0
// `);

const dropOption = ctl(`
block
my-4
mx-8
hover:text-primary
cursor-pointer
`);

// const selectPlaceholder = ctl(`
// text-secondary-700
// `)

const baseStyles = `
  md:w-[436px]
  w-full
  rounded-[50px]
  border
  border-secondary-400
  py-[20px]
  md:py-[25px]
  outline-none
  pl-[29px]
  focus:border-primary
`;

const inputErrorStyle = `
  border-action-error 
  bg-action-error-light
`;
const errorMessageWrapStyle = ctl(`
  flex 
  gap-2
  items-center
  mt-[10px]
`);
const errorMessageStyle = ctl(`
  text-[12px]
  text-action-error
  font-semibold
`);

FormSelect.propTypes = {
  register: PropTypes.object,
  required: PropTypes.bool,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  options: PropTypes.string,
};

export { FormSelect };
